import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { machineDefault } from 'Components/User/Orders/Machines'
import { apiOrdersHistories, apiOrdersList, apiOrdersView } from 'Services/UserService'

export const getData = createAsyncThunk('user/orders/getData', async datas => {
    const { data } = await apiOrdersList(datas)
    return data
})

export const getView = createAsyncThunk('user/orders/getView', async id => {
    if (!id) return viewData
    const { data } = await apiOrdersView(id)
    data.machines = data.machines && data.machines.length > 0 ? data.machines : [machineDefault]
    return data
})

export const getHistories = createAsyncThunk('user/orders/getHistories', async datas => {
    if (!datas.id) return []
    const { data } = await apiOrdersHistories(datas.id, datas)
    return data
})

const viewData = {
    customer_id: '',
    order_request_id: '',
    details: '',
    sub_total: '',
    gst: 18,
    gst_amount: '',
    total: '',
    start_date: '',
    end_date: '',
    machines: [],
    deliveries: [],
}

export const ordersSlice = createSlice({
    name: 'user/orders',
    initialState: {
        loading: true,
        view: viewData,
        histories: [],
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
                state.histories = []
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
                state.histories = []
            })
            .addCase(getHistories.fulfilled, (state, { meta, payload }) => {
                if (meta.arg.id) {
                    state.histories[meta.arg.id] = payload
                }
            })
    },
})

export const { setData, setTableData } = ordersSlice.actions

export default ordersSlice.reducer
